import { useRouter } from '@repo/ui/hooks/use-router';
import { lazy, Suspense } from 'react';

const CreateInventaireForm = lazy(() =>
  import('@repo/ui/features/inventaires/implentation/create-inventaire-form').then((mod) => ({
    default: mod.CreateInventaireForm,
  })),
);

export default function InventaireNewPage() {
  const router = useRouter();

  return (
    <div className="w-full py-6">
      <Suspense fallback={<div className="flex items-center justify-center h-96">Loading form...</div>}>
        <CreateInventaireForm
          onCancel={() => router.push('/admin/inventaires')}
          onSuccess={() => router.push('/admin/inventaires')}
        />
      </Suspense>
    </div>
  );
}
